import CryptoJS from 'crypto-js/crypto-js';

const encrypt_secret = '7fa03df9fe0e3f7e201625';
const decrypt_secret = '7fa03df9fe0e3f7e201625';
 
export function encrypt(string, url_encode=true) {

    let cryptobject = CryptoJS.AES.encrypt(string, encrypt_secret);

    // let encrypted = {
    //     key: cryptobject.key + '', // don't send this
    //     iv: cryptobject.iv + '', // don't send this
    //     salt: cryptobject.salt + '', // don't send this
    //     ciphertext: cryptobject.ciphertext + '', // don't send this
    //     str: cryptobject + '' // send or store this
    // } 
    // return encrypted;

    // let encrypted = (cryptobject + '').replace(/\//g, '%2F');
    let encrypted = (url_encode ? encodeURIComponent(cryptobject + '') : cryptobject + '');
    
    return encrypted;
}

export function decrypt(encrypted_string, url_encode=true) {
    // encrypted_string = encrypted_string.replace(/%2F/g, '/');
    encrypted_string = (url_encode ? decodeURIComponent(encrypted_string) : encrypted_string);

    return CryptoJS.AES.decrypt(encrypted_string, decrypt_secret).toString(CryptoJS.enc.Latin1);
}

export function encryptBase64(string) {
    return btoa(string);
}

export function decryptBase64(string) {
    return atob(string);
}

export function decryptAPI(data) {
    var master_key = process.env.VUE_APP_APP_KEY;

    master_key = master_key.substring(0, 32)
    
    // Decode the base64 data so we can separate iv and crypt text.
    var rawData = atob(data);
    // Split by 16 because my IV size
    var iv = rawData.substring(0, 16);
    var crypttext = rawData.substring(16);

    //Parsers
    crypttext = CryptoJS.enc.Latin1.parse(crypttext);
    iv = CryptoJS.enc.Latin1.parse(iv); 
    var key = CryptoJS.enc.Utf8.parse(master_key);

    // Decrypt
    var plaintextArray = CryptoJS.AES.decrypt(
        { ciphertext:  crypttext},
        key,
        {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7}
    );

    // Can be Utf8 too
    var resp = CryptoJS.enc.Latin1.stringify(plaintextArray);
    return resp;
}

export function decryptAPICP(data) {
    var master_key = process.env.VUE_APP_APP_KEY;
    var secret_key = process.env.VUE_APP_SECRET_KEY;
    var limit_key = process.env.VUE_APP_ENCRYPT_RECENT_LOCATION_SECRET_LIMIT || 32;
    // console.log({master_key,secret_key,limit_key})

    var halfLimit = parseInt(limit_key/2)
    var tmpAppKey = master_key.substring(0, halfLimit)

    var otherHalfLimit = parseInt(limit_key-tmpAppKey.length)
    var halfOtherHalfLimit = parseInt((limit_key-tmpAppKey.length)/2)

    var tmpSecretKey1 = secret_key.substring(0, halfOtherHalfLimit)
    var tmpSecretKey2 = secret_key.substring(halfOtherHalfLimit, otherHalfLimit)

    // master_key = master_key.substring(0, 32)
    master_key = tmpSecretKey2+tmpAppKey+tmpSecretKey1
    // console.log({master_key})
    
    // Decode the base64 data so we can separate iv and crypt text.
    var rawData = atob(data);
    // Split by 16 because my IV size
    var iv = rawData.substring(0, 16);
    var crypttext = rawData.substring(16);
    // console.log({iv,crypttext})

    //Parsers
    crypttext = CryptoJS.enc.Latin1.parse(crypttext);
    iv = CryptoJS.enc.Latin1.parse(iv); 
    var key = CryptoJS.enc.Utf8.parse(master_key);

    // Decrypt
    var plaintextArray = CryptoJS.AES.decrypt(
        { ciphertext:  crypttext},
        key,
        {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7}
    );

    // Can be Utf8 too
    var resp = CryptoJS.enc.Latin1.stringify(plaintextArray);
    console.log({resp})
    return resp;
}